import clsx from 'clsx'
import { X } from 'lucide-react'
import React from 'react'

import Styles from './FilterChip.module.scss'

export type FilterChipProps = {
  isActive: boolean
  clearLabel: string
  onClear?: () => void
  children: React.ReactNode
  className?: string
  testId?: string
}

const FilterChip = ({
  isActive,
  clearLabel,
  onClear,
  children,
  className,
  testId
}: FilterChipProps) => (
  <div
    className={clsx(Styles.chip, isActive && Styles.active, className)}
    data-testid={testId}>
    {children}
    {isActive && onClear && (
      <button
        type="button"
        className={Styles.clearButton}
        aria-label={clearLabel}
        onClick={onClear}>
        <X width={20} height={20} />
      </button>
    )}
  </div>
)

export default FilterChip
